import { GenerateOTPRequest } from '../api/otp/generateotp/generateotprequest';
import { GenerateOTPResponse, GenerateOTPResponseDtoImpl } from '../api/otp/generateotp/generateotpresponse';
import { APIFeatures } from '../util/apifeatures';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class GenerateOTPAPIProcessorImpl extends APIProcessorImpl<GenerateOTPRequest, GenerateOTPResponse>
{

   /*   execute(request: LoginRequest): void
    // {
    //     super.execute(request);
    // }  */
    //   execute()
    //  {
    //     let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
    //         APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.valid_subscriber));

    //         this.getAPISuccess(subscriberValidationResponse);
    //  } 

    onSuccess(responseMapper: ResponseMapper): void 
    {
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                if(responseMapper.getStatusCodeOutside() === "SC0000" ||
                responseMapper.getResponseMap().respCode === "000" 
                || responseMapper.getResponseMap().respCode === "SC0000")
                {
                    let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
                    APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.valid_subscriber));

                    this.getAPISuccess(subscriberValidationResponse);
                }
                else if(responseMapper.getResponseMap().respCode === "100")
                {//non-registered etisalath
                    let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
                    APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.subscriber_not_registered));

                    this.getAPIFailure(subscriberValidationResponse);
                }
                else if(responseMapper.getResponseMap().respCode === "002")
                {//password expired/ blocked by admin
                    let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
                    APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.password_blocked));

                    this.getAPIFailure(subscriberValidationResponse);
                }
                else
                {
                    //not -registered, not-etisalath
                    let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
                        APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));

                        this.getAPIFailure(subscriberValidationResponse);
                }
            }
        }
        catch(e)
        {
            this.getAPIFailure(new GenerateOTPResponseDtoImpl(APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        this.getAPIFailure(new GenerateOTPResponseDtoImpl(APIFeatures.GENERATE_OTP, responseMapper.getStatusMsg()));
        //   if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
        //     {
        //         if(responseMapper.getResponseMap().data.responseMap.respCode=== "000" 
        //         || responseMapper.getResponseMap().data.responseMap.respCode === "SC0000")
        //         {
        //             let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
        //             APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.valid_subscriber));

        //             this.getAPISuccess(subscriberValidationResponse);
        //         }
        //         else if(responseMapper.getResponseMap().data.responseMap.respCode === "100")
        //         {//non-registered etisalath
        //             let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
        //             APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.subscriber_not_registered));

        //             this.getAPIFailure(subscriberValidationResponse);
        //         }
        //         else if(responseMapper.getResponseMap().data.responseMap.respCode === "002")
        //         {//password expired/ blocked by admin
        //             let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
        //             APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.password_blocked));

        //             this.getAPIFailure(subscriberValidationResponse);
        //         }
        //         else
        //         {
        //             //not -registered, not-etisalath
        //             let subscriberValidationResponse = new GenerateOTPResponseDtoImpl(
        //                 APIFeatures.GENERATE_OTP, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));

        //                 this.getAPIFailure(subscriberValidationResponse);
        //         }
        //     }
        //     else
        //     {
        //         this.getAPIFailure(new GenerateOTPResponseDtoImpl(APIFeatures.GENERATE_OTP, responseMapper.getStatusMsg()));
        //     }
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/generateotpapiprocessor.tsx